import {Autocomplete, Drawer, Stack, TextField} from "@mui/material";
import React, {useState} from "react";
import type {BasePayers} from "../../firebase/index.js";
import {addExpense, ExpenseModel, getPayerByName, PayerModel, reimbursed, TripModel, updatePayers} from "../../firebase/index.js";
import {useInMemoryTrip} from "../../redux/InMemoryTripReducer.js";
import APXActionButtons from "../../reusables/APXActionButtons.jsx";
import type {BSLProps} from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import {hideNumberSpinner} from "../../reusables/js/APXCrucialStyles.js";


export default function AddNewReimbursementBSL({uid, onClose, payers}: BSLProps & { payers: BasePayers }) {
	  
	  const [paidByWhom, setPaidByWhom] = useState("");
	  const [paidToWhom, setPaidToWhom] = useState("");
	  const [paidHowMuch, setPaidHowMuch] = useState(0);
	  const [paidOn, setPaidOn] = useState("");
	  
	  const inMemoryTrip: TripModel = useInMemoryTrip();
	  
	  const {isOpen, handleOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  const handleCancel = () => {
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 if (/*FALSY->*/ !!!uid) {
					alert("Please login to add a new reimbursement");
					return;
			 }
			 if (paidByWhom.trim() === "" || paidToWhom.trim() === "" || paidHowMuch <= 0 || paidOn.trim() === "") {
					alert("Please fill all the fields");
					return;
			 }
			 if (paidByWhom === paidToWhom) {
					alert("Payer and Payee to cannot be same");
					return;
			 }
			 
			 const reimbursementExpense = new ExpenseModel(paidByWhom.trim(), paidHowMuch, new Date(paidOn).getTime(), `Reimbursed ${paidToWhom.trim()}`, true);
			 
			 reimbursed(getPayerByName(payers, paidByWhom.trim()), getPayerByName(payers, paidToWhom.trim()), paidHowMuch);
			 
			 addExpense(uid, inMemoryTrip.expenditureKey, reimbursementExpense.expenseKey, reimbursementExpense);
			 updatePayers(uid, inMemoryTrip.expenditureKey, payers);
			 
			 handleCancel();
			 
	  };
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  <Stack direction={{xs: "column", sm: "row"}} spacing={2}>
									 <Autocomplete sx={{ml: 1, width: {xs: "100%", sm: "20%"}}}
														clearOnEscape={false}
														disableClearable
														options={Object.values(payers).filter((payer: PayerModel) => payer.due > 0).map((payer: PayerModel) => payer.name)}
														renderInput={(params) => (
																  <TextField {...params} required label={"Paid by whom"} variant="outlined"
																				 inputProps={{...params.inputProps, readOnly: true}}/>
														)}
														value={paidByWhom}
														onChange={(event, newValue) => setPaidByWhom(newValue)}
									 />
									 <Autocomplete sx={{ml: 1, width: {xs: "100%", sm: "20%"}}}
														clearOnEscape={false}
														disableClearable
														options={Object.values(payers).filter((payer: PayerModel) => /*NOT->*/ !payer.isFrozen).map((payer: PayerModel) => payer.name)}
														renderInput={(params) => (
																  <TextField {...params} required label={"Paid to whom"} variant="outlined"
																				 inputProps={{...params.inputProps, readOnly: true}}/>
														)}
														value={paidToWhom}
														onChange={(event, newValue) => setPaidToWhom(newValue)}
									 />
									 <TextField
												fullWidth
												required
												variant="outlined"
												type={"number"}
												InputProps={hideNumberSpinner}
												label={"Paid how much"}
												value={paidHowMuch}
												onChange={(event) => setPaidHowMuch(Number(event.target.value))}
									 />
									 <TextField
												fullWidth
												required
												variant="outlined"
												type="date"
												label={"Paid on"}
												value={paidOn}
												InputLabelProps={{shrink: true}}
												InputProps={{
													  inputProps:
																 {
																		min: inMemoryTrip.getCreatedAtDate().toISOString().split("T")[0],
																		max: new Date().toISOString().split("T")[0]
																 }
												}}
												onChange={(event) => setPaidOn(event.target.value)}
									 />
							  </Stack>
							  <APXActionButtons onCancel={handleCancel} onAdd={handleAdd}
													  shouldShowConfirmationDialog={true}
													  validationProviderAllStateFields={[paidByWhom, paidToWhom, paidHowMuch, paidOn]}
													  validationProviderMustNotBeEqualStateFields={[[paidByWhom, paidToWhom]]}
							  />
						</Stack>
				 </Drawer>
	  );
}